// extracted by mini-css-extract-plugin
export var askAiIcon = "_mn-9";
export var container = "_mn-0";
export var groupSeparator = "_mn-a";
export var highlight = "_mn-4";
export var resultIcon = "_mn-5";
export var resultItem = "_mn-7";
export var resultSubtitle = "_mn-3";
export var resultTitle = "_mn-2";
export var resultsList = "_mn-1";
export var searchGroup = "_mn-6";
export var selected = "_mn-8";